import { motion, AnimatePresence } from 'motion/react';
import { useAuth } from '../../utils/Auth';
import { transition, variants } from './variants';
import { useBack } from '../../utils/hooks/useBack';
import Personal from './Personal';
import Account from './Account';
import QrArchive from './QrArchive';
import styles from './Settings.module.css';

export default function Settings() {
    const { userObj } = useAuth();
    const goBack = useBack('/collection');

    // AuthGuard already ensures currentUser and orgObj exist
    // Only need to wait for userObj to load
    if (!userObj) {
        return null;
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <AnimatePresence mode='wait'>
                    <motion.div
                        key='settings'
                        className={styles.details}
                        transition={{
                            ...transition,
                            duration: .5,
                        }}
                        variants={variants}
                        initial='initial'
                        animate='animate'
                        exit='initial'
                    >
                        <div className={styles.header}>
                            <button className={styles.backBtn} onClick={goBack}>
                                <i className='fas fa-arrow-left' style={{pointerEvents: 'none'}} />
                                Back
                            </button>
                            <h4 className={styles.title}>Account Settings</h4>
                            <div className={styles.spacer}></div>
                        </div>
                        <div className={styles.detailsInner}>
                            <AnimatePresence mode='wait'>
                                <motion.div
                                    key='sections'
                                    className={styles.motionWrap}
                                    transition={transition}
                                    variants={variants}
                                    initial='initial'
                                    animate='animate'
                                    exit='initial'
                                >
                                    <div className={styles.sectionsContainer}>
                                        {/* Personal Information Section */}
                                        <Personal />

                                        {/* Account Details Section */}
                                        <Account />

                                        {/* QR Settings Section */}
                                        <QrArchive />
                                    </div>
                                </motion.div>
                            </AnimatePresence>
                        </div>
                    </motion.div>
                </AnimatePresence>
            </div>
        </div>
    );
}
